module.exports = __webpack_public_path__ + "static/profile-img-c827cc4e150864e3902aac2d7b30d03d.png";